import React from "react";
import { ProjectState } from "../../../../shared";
import BlurControl from "./BlurControl";
import BrightnessControl from "./BrightnessControl";
import ContrastControl from "./ContrastControl";
import HueControl from "./HueControl";
import SaturationControl from "./SaturationControl";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type Props = {
  project: ProjectState
}

function ObjectDetectionControls({ project }: Props) {
  const lastSelectedLayer = useSelector((state: RootState) => state.project.lastSelectedLayer);
  const playing = useSelector((state: RootState) => state.canvas.playing);
  
  if (lastSelectedLayer === undefined || playing) {
    return null;
  }

  // const layer = project.layers[lastSelectedLayer];

  const objectNames = new Set<string>();
  objectNames.add("background");
  project.layers.forEach(layer => {
    layer?.detectedObjects?.forEach((d) => {
      objectNames.add(d.name);
    })
  });

  return (
    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    }}>
        {Array.from(objectNames).map((name, i) => {
        return (
            <div
                key={i}
                style={{
                    color: 'white',
                    backgroundColor: 'black',
                    padding: 16,
                    margin: 16,
                }}>
                    <h1>{name}</h1>
                    <BrightnessControl 
                        project={project} 
                        name={name}
                    />
                    <ContrastControl 
                        project={project} 
                        name={name}
                    />
                    <HueControl 
                        project={project} 
                        name={name}
                    />
                    <SaturationControl 
                        project={project} 
                        name={name}
                    />
                    <BlurControl
                        project={project} 
                        name={name}
                    />
            </div>
        )
        })}
    </div>
  );
}

export default ObjectDetectionControls;